<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'App',
    
    mounted() {
      const token = sessionStorage.getItem('token'); // @TODO

      if (token) {
        this.$socket.client.io.opts.query = { token };
        this.$socket.client.open();
      }
    },

    sockets: {
      connect: function() {
        this.$socket.client.emit('authenticate', { token: sessionStorage.getItem('token') }); // @TODO
      }
    }
  }
</script>

<style>
  html, body, #app {
    height: 100%;
  }

  .row.no-gutters {
    margin-right: 0;
    margin-left: 0;
  }

  .row.no-gutters > [class*="col-"] {
    padding-left: 0;
    padding-right: 0;
  }

  .form-group {
    margin-bottom: 1rem;
  }

  h1, h2, h3 {
    margin-bottom: 1em;
  }

  h1 {
    font-size: 1.5em;
  }

  h2 {
    font-size: 1.25em;
  }

  h3 {
    font-size: 1.15em;
  }

  p {
    margin-bottom: 1em;
  }

  p:last-child {
    margin-bottom: 0;
  }
</style>